import "./styles.scss";

import React from "react";

import { ReactComponent as ArrowIcon } from "assets/icons/new/forward-arrow.svg";

const mainClass = "pagination";

const getPages = (currentPage, totalPages) => {
  if (totalPages <= 1) return [1];

  const set = new Set();
  set.add(1);
  set.add(totalPages);

  for (
    let p = Math.max(1, currentPage - 1);
    p <= Math.min(totalPages, currentPage + 1);
    p++
  ) {
    set.add(p);
  }

  const sorted = Array.from(set).sort((a, b) => a - b);

  const result = [];
  for (let i = 0; i < sorted.length; i++) {
    if (i > 0 && sorted[i] - sorted[i - 1] > 1) {
      result.push("...");
    }
    result.push(sorted[i]);
  }

  return result;
};

const Pagination = ({ currentPage, totalPages, onChange }) => {
  if (!totalPages || totalPages <= 1) return null;

  const pages = getPages(currentPage, totalPages);

  return (
    <div className={mainClass}>
      <button
        className={`${mainClass}__item ${mainClass}__arrow`}
        onClick={() => onChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <ArrowIcon />
      </button>
      {pages.map((page, i) =>
        page === "..." ? (
          <span key={`ellipsis-${i}`} className={`${mainClass}__ellipsis`}>
            ...
          </span>
        ) : (
          <button
            key={page}
            className={`${mainClass}__item${
              currentPage === page ? ` ${mainClass}__item--active` : ""
            }`}
            onClick={() => onChange(page)}
          >
            {page}
          </button>
        ),
      )}
      <button
        className={`${mainClass}__item ${mainClass}__arrow`}
        onClick={() => onChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <ArrowIcon />
      </button>
    </div>
  );
};

export default Pagination;
